export const getPriorityRole = (roles = []) => {
  const priorityRole = roles?.sort((a, b) => a?.id - b?.id)?.[0];
  return priorityRole?.description || "Normal User";
};
